import React, { Component } from 'react'
import styled from 'styled-components'

const stars = (score = 0) =>
  Array(Math.floor(score)).fill(1).concat([
    Math.round((score % 1) * 10) / 10, 0, 0, 0, 0
  ]).slice(0, 5)
const starIcons = (score = 0) => stars(score).map((value, index) => {
  return `/images/star-icon-${10 * value}.png`
})

export default class extends Component {
  render () {
    const { score, children } = this.props
    return (
      <Container>
        {starIcons(score).map((src, index) =>
          <ReviewStar key={index}>
            <img alt='' src={src} />
          </ReviewStar>
        )}
        {children}
      </Container>
    )
  }
}

const Container = styled.div`

`
const ReviewStar = styled.div`
  display: inline-block;
  vertical-align: top;

  margin-right: 3px;

  @media(min-width: 768px) {
    > img {
      width: 20px;
      height: 20px;
    }
  }
  @media(min-width: 414px) and (max-width: 767px) {
    > img {
      width: 16px;
      height: 16px;
    }
  }
  @media(max-width: 413px) {
    > img {
      width: 12px;
      height: 12px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/ReviewStars.js